import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./auth/slice";
import uploadFileSlice from "./uploadFile/slice";
import recipeSlice from "./nutrition-recipes/slice";
import communalGardenSlice from "./communalgarden/slice";
import movementSlice from "./movement/slice";
import tipsSlice from "./nutrition-tips/slice";
import affirmationSlice from "./affirmation/slice";
import audioSlice from "./audio/slice";
import usersSlice from "./user/slice";
import videoSlice from "./video/slice";
import notificationSlice from "./notification/slice";
import testerSlice from "./tester/slice";
import sectionSlice from "./section/slice";

const rootReducer = {
  authData: authSlice,
  uploadFileData: uploadFileSlice,
  recipeData: recipeSlice,
  communalGardenData: communalGardenSlice,
  movementData: movementSlice,
  tipsData: tipsSlice,
  affirmationData: affirmationSlice,
  audioData: audioSlice,
  usersData: usersSlice,
  videoData: videoSlice,
  notificationData: notificationSlice,
  userTesterData: testerSlice,
  sectionData: sectionSlice,
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
